// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-title-content::ng-deep app-title {
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.form-container {
  display: flex;
  flex-flow: column nowrap;
  row-gap: var(--space-md);
  width: 100%;
  transform-origin: center;
}
.form-container flw-input {
  --width: 100%;
}
.form-container .autoFillDataBtn {
  margin-bottom: var(--space-md);
}
.form-container .referrer-code-container {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  width: 100%;
}
.form-container .referrer-code-container .referrer-code-input {
  flex: 1;
  min-width: 0;
}
.form-container .referrer-code-container flw-button flw-icon {
  --cursor: pointer;
}
.form-container .referrer-code-container flw-button::part(native) {
  height: 48px;
}
.form-container .privacy-text {
  color: var(--color-action-primary);
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.form-container .checkboxes {
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.form-container .checkboxes flw-checkbox {
  width: 100%;
}
.form-container .checkbox-text {
  color: var(--color-grey-400, #535355);
  font-size: var(--font-body-small-size);
  font-style: normal;
  font-weight: var(--font-body-small-weight);
  line-height: var(--font-body-small-line-height);
}
.form-container .communication-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}
.form-container .communication-section .communication-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-container .communication-section .communication-header .accept-all-btn {
  background: transparent;
  padding: 0;
  color: var(--ion-color-primary);
  font-size: var(--font-size-xs);
  font-weight: normal;
  cursor: pointer;
  text-decoration: underline;
}
.form-container .communication-section .communication-channels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: var(--space-md) var(--space-xs);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/register-form/register-form.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,wBAAA;AAFJ;AAII;EACI,aAAA;AAFR;AAKI;EACE,8BAAA;AAHN;AAMI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AAJR;AAMQ;EACI,OAAA;EACA,YAAA;AAJZ;AAOQ;EACI,iBAAA;AALZ;AAQQ;EACI,YAAA;AANZ;AAUI;EACI,kCAAA;EACA,eAAA;EACA,+BAAA;EACA,4BAAA;EACA,iCAAA;UAAA,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCAAA;AARR;AAWI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AATR;AAWQ;EACI,WAAA;AATZ;AAaI;EACI,qCAAA;EACA,sCAAA;EACA,kBAAA;EACA,0CAAA;EACA,+CAAA;AAXR;AAcI;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAZR;AAcQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAZZ;AAcY;EACI,uBAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAZhB;AAgBQ;EACI,aAAA;EACA,2DAAA;EACA,oCAAA;AAdZ","sourcesContent":[".register-title-content {\r\n    &::ng-deep app-title {\r\n        font-size: 36px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        line-height: normal;\r\n    }\r\n}\r\n\r\n\r\n.form-container {\r\n    display: flex;\r\n    flex-flow: column nowrap;\r\n    row-gap: var(--space-md);\r\n    width: 100%;\r\n    transform-origin: center;\r\n\r\n    flw-input {\r\n        --width: 100%;\r\n    }\r\n\r\n    .autoFillDataBtn {\r\n      margin-bottom: var(--space-md);\r\n    }\r\n\r\n    .referrer-code-container {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: var(--space-sm);\r\n        width: 100%;\r\n\r\n        .referrer-code-input {\r\n            flex: 1;\r\n            min-width: 0;\r\n        }\r\n\r\n        flw-button flw-icon {\r\n            --cursor: pointer;\r\n        }\r\n\r\n        flw-button::part(native) {\r\n            height: 48px;\r\n        }\r\n    }\r\n\r\n    .privacy-text {\r\n        color: var(--color-action-primary);\r\n        cursor: pointer;\r\n        text-decoration-line: underline;\r\n        text-decoration-style: solid;\r\n        text-decoration-skip-ink: auto;\r\n        text-decoration-thickness: auto;\r\n        text-underline-offset: auto;\r\n        text-underline-position: from-font;\r\n    }\r\n\r\n    .checkboxes {\r\n        margin-top: 30px;\r\n        margin-bottom: 30px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 30px;\r\n\r\n        flw-checkbox {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .checkbox-text {\r\n        color: var(--color-grey-400, #535355);\r\n        font-size: var(--font-body-small-size);\r\n        font-style: normal;\r\n        font-weight: var(--font-body-small-weight);\r\n        line-height: var(--font-body-small-line-height);\r\n    }\r\n\r\n    .communication-section {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: var(--space-md);\r\n\r\n        .communication-header {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n\r\n            .accept-all-btn {\r\n                background: transparent;\r\n                padding: 0;\r\n                color: var(--ion-color-primary);\r\n                font-size: var(--font-size-xs);\r\n                font-weight: normal;\r\n                cursor: pointer;\r\n                text-decoration: underline;\r\n            }\r\n        }\r\n\r\n        .communication-channels {\r\n            display: grid;\r\n            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\r\n            gap: var(--space-md) var(--space-xs);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
